import { render, staticRenderFns } from "./DetectSuspiciousVariations.vue?vue&type=template&id=7c9ef276&"
import script from "./DetectSuspiciousVariations.vue?vue&type=script&lang=js&"
export * from "./DetectSuspiciousVariations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports